export default __webpack_public_path__ + "static/media/absolute-capital.18477798.jpg";